//Material imports
import makeStyles from "@mui/styles/makeStyles";
export const groupSignUpPageStyles = makeStyles(theme => ({
  container: {
    backgroundImage: "url(/signup_page_bg.png)",
    height: "100%",
    backgroundPosition: "22%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "fixed",
    margin: "auto",
    paddingBottom: "5%",
    overflowY: "auto",
    width: "100%"
  },
  signUpForm: {
    ...theme.grid.gridTemplateContainer,
    gap: 20,
    minWidth: 200,
    marginTop: 40,
    gridTemplateAreas: `"email"
                            "password"
                            "firstName"
                            "lastName"
                            "country"
                            "countryCaption"
                            "state"
                            "terms"`,
    textAlign: "left"
  },
  signUpFormWrapper: {
    zIndex: 1,
    zoom: "80%",
    height: "60%",
    margin: "auto",
    maxWidth: "80%",
    background: "white",
    marginTop: 200,
    borderRadius: 30,
    padding: "30px"
  },
  logo: {
    zIndex: -1,
    left: 20,
    top: 20,
    maxWidth: 150,
    position: "fixed"
  },
  input: {
    marginTop: 10,
    background: theme.palette.background.default
  },
  email: {
    gridArea: "email"
  },
  password: {
    gridArea: "password"
  },
  firstName: {
    gridArea: "firstName"
  },
  lastName: {
    gridArea: "lastName"
  },
  country: {
    gridArea: "country"
  },
  state: {
    gridArea: "state"
  },
  countryCaption: {
    gridArea: "countryCaption",
    marginTop: -15
  },
  signUpButton: {
    gridArea: "signUpButton"
  },
  autoCompleteRoot: {
    "& .MuiFormControl-root": {
      background: theme.palette.background.default
    },
    "& .MuiInputBase-input": {
      padding: 0,
      display: "inline-flex"
    },
    marginTop: 10
  },
  textInputClasses: {
    marginTop: 30
  },
  selectRoot: {
    background: theme.palette.background.default
  },
  termsContainer: {
    gridArea: "terms",
    borderRadius: 70,
    marginTop: 10
  },
  singleTerm: {
    display: "flex",
    alignItems: "center"
  },
  termsText: {
    "&:hover": {
      cursor: "pointer"
    }
  },
  privacyInfo: {
    whitSpace: "pre-wrap",
    marginTop: 20,
    marginBottom: 20,
    justifyContent: "center"
  },
  termsTextDisabled: {
    color: theme.palette.action.disabled,
    "&:hover": {
      cursor: "default"
    }
  },
  [theme.breakpoints.up("sm")]: {
    container: {
      backgroundPosition: "-250px"
    },
    signUpFormWrapper: {
      padding: 30
    }
  },
  [theme.breakpoints.up("md")]: {
    signUpForm: {
      gridTemplateColumns: "1fr 1fr",
      gridTemplateAreas: `"email ."
                                "password ."
                                "firstName lastName"
                                "country state"
                                "countryCaption ."
                                "terms terms"`
    },
    privacyInfo: {
      justifyContent: "flex-start"
    },
    logo: {
      left: 30,
      top: 30,
      maxWidth: 200
    },
    signUpFormWrapper: {
      marginLeft: 300,
      marginRight: "5%",
      maxWidth: "100%",
      marginTop: 0
    },
    container: {
      backgroundPosition: "15%",
      paddingTop: 180
    }
  },
  [theme.breakpoints.up("lg")]: {
    signUpFormWrapper: {
      maxWidth: 1200,
      marginLeft: 400
    }
  },
  [theme.breakpoints.up("xl")]: {
    container: {
      height: "100%",
      backgroundPosition: "0px -10px"
    },
    signUpFormWrapper: {
      marginLeft: "30%"
    }
  }
}));